module.exports = __webpack_public_path__ + "static/img/nishii.4716758.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/nishii.png
// module id = enTZ
// module chunks = 0